// import { differenceInCalendarDays } from "date-fns";
import { defaultItemOptions } from "../elements/formBuilder/toolbar/defaults";
import { getSheetNameFromAddress } from "../utils/helperExcel";
import { nanoid } from 'nanoid';
// import { isValidDate } from "../utils/helper";

const ELEMENT_TYPES_PER_DATA_TYPE = {
  'number': ['Range', 'NumberInput'],
  'text': ['Header', 'TextInput', 'TextArea'],
  'date': ['DatePicker', 'TimePicker'],
  'boolean': ['Checkbox', 'RadioButtons'],
  'formula': ['ResultCell', ]
}

export function getHelperTables(tables) {
  if (!tables) return [];

  let helperTables = [];
  tables.forEach((tempTable) => {
    if (tempTable.name.includes("AR_")) {
      helperTables.push(tempTable.name);
    }
  });
  return helperTables;
}

function hasCurlyBrackets(elementId) {
  if (!elementId) return false;
  return elementId.includes("{");
}

export function getWorksheetUrlSection(worksheetId) {
  if (!worksheetId) return;

  if (hasCurlyBrackets(worksheetId)) {
    return "worksheets/" + worksheetId;
  } else {
    return "worksheets('" + worksheetId + "')";
  }
}

export function getWorksheetIdFromAddress(address, workSheets) {
  if (!address) return;
  if (!workSheets) return;
  const worksheetName = getSheetNameFromAddress(address).replaceAll("'", "").toLowerCase();
  let worksheetId = workSheets.find((x) => x.name?.toLowerCase() === worksheetName).id;
  return worksheetId;
}

export function determineDataType(value) {
  if (typeof value === "boolean") {
    return "boolean";
  } else if (value instanceof Date && !isNaN(value)) {
    return "date";
  } else if (!isNaN(parseFloat(value)) && isFinite(value)) {
    return "number";
  } else {
    return "text";
  }
}

export function getElementTypeFromCell(dataType) {
  const possibles = ELEMENT_TYPES_PER_DATA_TYPE[dataType];
  return randomItem(possibles);
}

export function createElementItem(item) {
  if (!item) return;
  
  const elementOptions = {
    id: nanoid(),
    element: item.element || item.key,
    text: item.name,
    static: item.static,
    required: false,
    showDescription: item.showDescription ? item.showDescription : false,
  };

  if (!item.static) {
    elementOptions.showDescription = true;
  }

  if (item.type === 'custom') {
    elementOptions.key = item.key;
    elementOptions.custom = true;
    elementOptions.forwardRef = item.forwardRef;
    elementOptions.bare = item.bare;
    elementOptions.props = item.props;
    elementOptions.component = item.component || null;
    elementOptions.custom_options = item.custom_options || [];
  }

  if (item.canHaveAnswer) { elementOptions.canHaveAnswer = item.canHaveAnswer; }
  if (item.hidden) { elementOptions.hidden = true; }

  if (item.canReadOnly) { elementOptions.readOnly = false; }

  if (item.content) { elementOptions.content = item.content; }

  if (item.href) { elementOptions.href = item.href; }

  if (item.class_name) {
    elementOptions.class_name = item.class_name;
  }

  if (item.key === 'Image') {
    elementOptions.src = item.src;
    elementOptions.cell = item.cell;
  }

  if (item.key === 'DatePicker') {
    elementOptions.dateFormat = item.dateFormat;
    elementOptions.timeFormat = item.timeFormat;
    elementOptions.cell = item.cell;
    elementOptions.dateSelector = item.dateSelector;
  }

  if (item.key === 'TimePicker') {
    elementOptions.timeFormat = item.timeFormat;
    elementOptions.cell = item.cell;
  }

  if (item.key === 'Label') {
    elementOptions.cell = item.cell;
  }

  if (item.key === 'ResultCell') {
    elementOptions.cell = item.cell;
    elementOptions.showCaptionInside = item.showCaptionInside;
    elementOptions.sizeSmall = true;
  }

  if (item.key === 'Dropdown') {
    elementOptions.cell = item.cell;
    elementOptions.source_address = item.source_address;
  }

  if (item.key === 'TextArea') {
    elementOptions.cell = item.cell;
  }

  if (item.key === 'HyperLink') {
    elementOptions.cell = item.cell;
  }

  if (item.key === 'RadioButtons') {
    elementOptions.cell = item.cell;
    elementOptions.inline = item.inline;
  }

  if (item.key === 'ActionButton') {
    elementOptions.endpoint_url = item.endpoint_url;
    elementOptions.open_url = item.open_url;
    elementOptions.background_imarge_url = item.background_imarge_url;
  }

  if (item.key === 'NumberInput') {
    elementOptions.editor_style = item.editor_style;
    elementOptions.step = item.step;
    elementOptions.min_value = item.min_value;
    elementOptions.max_value = item.max_value;
    elementOptions.min_label = item.min_label;
    elementOptions.max_label = item.max_label;
    elementOptions.cell = item.cell;
    elementOptions.show_buttons = item.show_buttons ?? false;
  }

  if (item.key === 'TextInput') {
    elementOptions.cell = item.cell;
  }

  if (item.key === 'ResultTable') {
    elementOptions.address = item.address;
    elementOptions.conditional_colors = true;
  }

  if (item.key === 'SpreadTable') {
    elementOptions.address = item.address;
    elementOptions.conditional_colors = true;
  }

  if (item.key === 'TableView') {
    elementOptions.address = item.address;
    elementOptions.conditional_colors = true;
  }

  if (item.key === 'Checkbox') {
    elementOptions.cell = item.cell;
  }

  if (item.key === 'Range') {
    elementOptions.editor_style = item.editor_style;
    elementOptions.step = item.step;
    elementOptions.min_value = item.min_value;
    elementOptions.max_value = item.max_value;
    elementOptions.min_label = item.min_label;
    elementOptions.max_label = item.max_label;
    elementOptions.show_tooltip = true;
    elementOptions.show_buttons = true;
    elementOptions.cell = item.cell;
  }

  if (item.defaultValue) { elementOptions.defaultValue = item.defaultValue; }

  if (item.field_name) { elementOptions.field_name = item.field_name + nanoid(); }

  if (item.label) { elementOptions.label = item.label; }

  if (item.options) {
    if (item.options.length > 0) {
      elementOptions.options = item.options;
    } else {
      elementOptions.options = defaultItemOptions(elementOptions.element);
    }
  }

  return elementOptions;
}

function randomItem(items)
{
  return items[Math.floor(Math.random()*items.length)];
}

// export function getDayDifferenceToEndDate(endDate) {
//   // is there an end date
//   if (isValidDate(endDate)) {
//     const todayDate = new Date();
//     const dayDifference = differenceInCalendarDays(endDate, todayDate);
//     return dayDifference;
//   }
//   return null;
// }

// function checkEndDateStatus(dayDifference, status) {
//   if (!dayDifference) return status;
//   if (dayDifference >= 0) return status;

//   return "overdue";
// }

// export function getExcelDateValue(value) {
//   let result = value ? getJsDateFromExcel(value) : null;
//   return result;
// }
